import React from 'react'
import PropTypes from 'prop-types'

import ErrorBoundary from 'lib/tags/error-boundary'

const Widget = ({ children, className, ...props }) => (
  <ErrorBoundary className={className || 'widget space'} errorClassName='has-errors' {...props}>
    {children}
  </ErrorBoundary>
)

Widget.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default Widget
